<template>
  <div class="c-dropdown-filter">
    <label :for="label" class="c-dropdown-filter__label" :class="[value ? '' : 'visually-hidden']">
      {{ label }}
    </label>
    <select :name="label" :id="label" class="c-dropdown-filter__select" @input="updateValue" @change="hasChanged" :class="[value ? 'c-dropdown-filter__select--selected' : '']">
      <option value="">{{ label }}</option>
      <option v-for="item in options" :value="item" :key="item">{{ item }}</option>
    </select>
    <svg class="c-dropdown-filter__icon" aria-hidden="true" focusable="false">
      <use xmlns:xlink="http://www.w3.org/1999/xlink" xlink:href="#arrow-down"></use>
    </svg>
  </div>
</template>

<script>
  export default {
    props: {
      label: {
        type: String,
        required: true,
      },
      options: {
        type: Array,
        required: true,
      },
      value: {
        type: String,
        required: false,
        default: ''
      },
    },
    methods: {
        updateValue(event) {
            this.$emit('input', event.target.value)
        },
        hasChanged() {
            this.$emit('changed', true)
        },
    },
  }
</script>


// WEBPACK FOOTER //
// src/components/components/reportAProblem/_filter/filter-dropdown/FilterDropdown.vue